import { createI18n } from 'vue-i18n'
import { type UserModule } from '~/types'

const messages = Object.fromEntries(
  Object.entries(
    import.meta.glob<{ default: any }>('../../../locales/*.y(a)?ml', { eager: true }))
    .map(([key, value]) => {
      return [key.slice(17, -4), value.default]
    }),
)

const i18nInstance: any = createI18n({
  legacy: false,
  locale: navigator.language.split('-')[0],
  fallbackLocale: 'en',
  messages,
  datetimeFormats :{
		en: {
			short: {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
			},
			long: {
				year: 'numeric',
				month: 'short',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
			},
			longDateOnly: {
				year: 'numeric',
				month: 'short',
				day: 'numeric',
			},
		},
	},
})

export const install: UserModule = ({ app }) => {
  app.use(i18nInstance)
}

export const i18n = i18nInstance.global
